import type { ColumnDef } from "@tanstack/react-table";

import { DataTableViewOptions } from "@/components/DataTable/Table/DataTableViewOptions";

import type { BoardMemberTableRow } from "../-types";

/** アクションカラム（DataTableViewOptionsを表示するため） */
export function actionsColumn(): ColumnDef<BoardMemberTableRow> {
  return {
    id: "actions",
    header: ({ table }) => (
      <div className="flex justify-end pr-2">
        <DataTableViewOptions table={table} />
      </div>
    ),
    cell: () => null,
    enableHiding: false,
  };
}
